import { StoreState } from '@/redux/types';

export const getDesigns = (state: StoreState) => {
  return state.designs.detail;
};
